import {
  updateResourceState,
  createResourceReducer,
  normalizeResourceState,
  RESOURCE
} from '@unicus/react-ui-kit';

import {
  PATIENT,
  PATIENT_CREATE_ATTENDANCE,
  PATIENT_VIEW,
  PATIENT_VIEW_FINISHED,
  PATIENT_VIEW_UPDATE,
  PATIENT_EVENT_FETCH,
  PATIENT_EVENT_FETCH_FINISHED,
  PATIENT_EVENT_UNLOAD,
  PATIENT_EVENT_CREATE_ANNOTATION,
  PATIENT_EVENT_CREATE_ANNOTATION_FINISHED,
  PATIENT_EVENT_LINK_TREATMENT_FINISHED,
  PATIENT_EVENT_SHARE_FINISHED,
  PATIENT_SHOW_EVENTS,
  PATIENT_SHOW_ACTIVITIES,
  PATIENT_SHOW_SCHEDULES,
  PATIENT_CLOSE_SCHEDULES,
  PATIENT_EVENT_PRESCRIPTION_SHOW,
  PATIENT_EVENT_PRESCRIPTION_CLOSE,
  PATIENT_EVENT,
  PATIENT_EVENT_FINISHED,
  PATIENT_PRESCRIPTION_CREATE_INTEGRATED,
  PATIENT_PRESCRIPTION_CREATE_INTEGRATED_FINISHED,
  PATIENT_OPEN_ANNOTATION,
  PATIENT_CLOSE_ANNOTATION,
  PATIENT_EVENT_LIST_OPEN_FILTER,
  PATIENT_EVENT_LIST_CLOSE_FILTER,
  PATIENT_GET_TAGS_FINISHED,
  PATIENT_CREATE_TAG,
  PATIENT_REMOVE_TAG,
  PATIENT_CLOSE_FINANCIALENTRY,
  PATIENT_SHOW_FINANCIALENTRY,
  PATIENT_LIST_REFRESH
} from './patientActions';

const handleError = (state, action) => {
  return updateResourceState(
    state,
    action,
    RESOURCE,
    ({ createAnnotationData }) => ({
      loading: false,
      saving: false,
      redirecting: false,
      createAnnotationData: createAnnotationData
        ? { ...createAnnotationData, loading: false }
        : null
    })
  );
};

const patientReducer = createResourceReducer(
  PATIENT,
  [],
  {
    [PATIENT_VIEW](state, action) {
      const newState = normalizeResourceState(state, action.resource);
      return updateResourceState(newState, action, RESOURCE, () => ({
        loading: true
      }));
    },

    [PATIENT_LIST_REFRESH](state, action) {
      const newState = normalizeResourceState(state, action.resource);
      return updateResourceState(newState, action, RESOURCE, () => ({
        loaded: false
      }));
    },

    [PATIENT_EVENT_FETCH](state, action) {
      const newState = normalizeResourceState(state, action.resource);
      return updateResourceState(
        newState,
        action,
        RESOURCE,
        ({ events = {} }) => ({
          events: {
            ...events,
            loading: true
          }
        })
      );
    },

    [PATIENT_EVENT_FETCH_FINISHED](state, action) {
      const page = Number(action.payload.config.params.page) || 1;

      return updateResourceState(state, action, RESOURCE, ({ events = {} }) => {
        const { items = [], pagination = {} } = events;

        const newItems =
          page === 1
            ? action.payload.data.result.items
            : [...items, ...action.payload.data.result.items];

        return {
          events: {
            ...events,
            pagination: {
              ...pagination,
              total: action.payload.data.result.totalCount,
              current: page
            },
            queryParams: action.payload.config.params,
            items: [...newItems],
            editing: false,
            loaded: true,
            saving: false,
            loading: false
          }
        };
      });
    },

    [PATIENT_VIEW_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        loading: false,
        resourceView: action.payload.data.result
      }));
    },

    [PATIENT_VIEW_UPDATE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        resourceView: action.payload
      }));
    },

    [PATIENT_CREATE_ATTENDANCE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        creatingService: action.payload
      }));
    },

    [PATIENT_EVENT_UNLOAD](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        events: {}
      }));
    },

    [PATIENT_EVENT_LINK_TREATMENT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, ({ events = {} }) => {
        const { items = [], pagination } = events;

        return {
          events: {
            ...events,
            items: items.map((c) => {
              if (c.id === action.payload.data.result.id) {
                return action.payload.data.result;
              }

              return c;
            }),
            pagination: {
              ...pagination,
              total: pagination.total + 1
            }
          }
        };
      });
    },

    [PATIENT_EVENT_SHARE_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, ({ events = {} }) => {
        const { items = [], pagination } = events;

        return {
          events: {
            ...events,
            items: items.map((c) => {
              if (c.id === action.payload.data.result.id) {
                return action.payload.data.result;
              }

              return c;
            }),
            pagination: {
              ...pagination,
              total: pagination.total + 1
            }
          }
        };
      });
    },

    [PATIENT_SHOW_EVENTS](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        show: 'EVENTS'
      }));
    },

    [PATIENT_SHOW_ACTIVITIES](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        show: 'ACTIVITIES'
      }));
    },

    [PATIENT_SHOW_SCHEDULES](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        showSchedulesPatientId: action.payload
      }));
    },

    [PATIENT_CLOSE_SCHEDULES](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        showSchedulesPatientId: null
      }));
    },

    [PATIENT_EVENT_PRESCRIPTION_SHOW](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        eventPrescription: true
      }));
    },

    [PATIENT_EVENT_PRESCRIPTION_CLOSE](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        eventPrescription: false
      }));
    },

    [PATIENT_EVENT](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        saving: true
      }));
    },

    [PATIENT_EVENT_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, ({ events = {} }) => {
        const { items = [], pagination } = events;

        return {
          eventPrescription: false,
          saving: false,
          events: {
            ...events,
            items: [action.payload.data.result, ...items],
            pagination: {
              ...pagination,
              total: pagination.total + 1
            }
          }
        };
      });
    },

    [PATIENT_PRESCRIPTION_CREATE_INTEGRATED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        redirecting: true
      }));
    },

    [PATIENT_PRESCRIPTION_CREATE_INTEGRATED_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        redirecting: false
      }));
    },

    [PATIENT_OPEN_ANNOTATION](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          createAnnotationData: {
            patient: action.payload,
            loading: false
          }
        };
      });
    },

    [PATIENT_CLOSE_ANNOTATION](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          createAnnotationData: null
        };
      });
    },

    [PATIENT_EVENT_CREATE_ANNOTATION](state, action) {
      return updateResourceState(
        state,
        action,
        RESOURCE,
        ({ createAnnotationData = {} }) => ({
          createAnnotationData: {
            ...createAnnotationData,
            loading: true
          }
        })
      );
    },

    [PATIENT_EVENT_CREATE_ANNOTATION_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, ({ events = {} }) => {
        const { items = [], pagination } = events;

        return {
          createAnnotationData: null,
          events: {
            ...events,
            items: [action.payload.data.result, ...items],
            pagination: {
              ...pagination,
              total: pagination?.total + 1
            }
          }
        };
      });
    },

    [PATIENT_EVENT_LIST_OPEN_FILTER](state, action) {
      return updateResourceState(state, action, RESOURCE, ({ events = {} }) => {
        return {
          events: {
            ...events,
            openFilter: true
          }
        };
      });
    },

    [PATIENT_EVENT_LIST_CLOSE_FILTER](state, action) {
      return updateResourceState(state, action, RESOURCE, ({ events = {} }) => {
        return {
          events: {
            ...events,
            openFilter: false
          }
        };
      });
    },

    [PATIENT_GET_TAGS_FINISHED](state, action) {
      return updateResourceState(state, action, RESOURCE, () => {
        return {
          tags: action.payload?.data?.result ?? []
        };
      });
    },

    [PATIENT_CREATE_TAG](state, action) {
      return updateResourceState(state, action, RESOURCE, ({ tags = [] }) => {
        return {
          tags: [...tags, { tag: action.payload }]
        };
      });
    },

    [PATIENT_REMOVE_TAG](state, action) {
      return updateResourceState(state, action, RESOURCE, ({ tags = [] }) => {
        return {
          tags: tags.filter((c) => c.id !== action.payload)
        };
      });
    },

    [PATIENT_SHOW_FINANCIALENTRY](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        visibleFinancialEntryPatientId: action.payload
      }));
    },

    [PATIENT_CLOSE_FINANCIALENTRY](state, action) {
      return updateResourceState(state, action, RESOURCE, () => ({
        visibleFinancialEntryPatientId: null
      }));
    }
  },
  handleError
);

export default patientReducer;
